module.exports = __webpack_public_path__ + "media/bootstrap-icons/briefcase-fill-e753f3d4.svg";